<template>
  <div class="modal" v-show="show">
    <v-dialog v-model="value" persistent max-width="600px">
      <v-card>
        <v-toolbar color="green lighten-1 " dark>
          <v-toolbar-title class="headline"
            >{{ Headline }} {{ removeItem.name }}</v-toolbar-title
          >
        </v-toolbar>
        <v-card-text>
          <p>
            {{ WarningText }}
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn dark color="red darken-1" @click="show = false">
            Ångra
          </v-btn>
          <v-btn color="green lighten-1" text dark @click="remove()">
            Arkivera
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  created() {},

  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  name: "ArchiveWindow",
  props: {
    value: {
      required: true,
    },
    removeItem: Object,
    WarningText: String,
    Headline: String,
    Type: String,
  },
  methods: {
    ...mapActions("violations", ["archiveViolation"]),
    ...mapActions(["showSuccessSnackbar"]),

    remove() {
      if (this.Type == "violation") {
        this.archiveViolation(this.removeItem);
        this.showSuccessSnackbar(
          "Du har nu arkiverat kränkningsärendet. " 
        );
      }
      this.$emit('childToParent', false)
      this.show = false;
    },
  },
};
</script>




    <style lang="css" scoped>
.modal {
  background-color: rgba(0, 0, 0, 0.7);
}
</style>